import React from 'react';
import { Outlet } from 'react-router-dom';

const EspaceClientLayout: React.FC = () => {
  return <Outlet />;
};

export default EspaceClientLayout;
